import React from "react";
import PropTypes from "prop-types";
import Main from "../components/Main/";
import { connect } from "react-redux";
import injectSheet from "react-jss";
import Helmet from "react-helmet";
import { FacebookProvider, Like } from 'react-facebook';
import _ from "lodash";
require("core-js/fn/array/find");
require("prismjs/themes/prism-okaidia.css");

import { setNavigatorPosition, setNavigatorShape } from "../state/store";
import { moveNavigatorAside } from "../utils/shared";
import Masonary from "../components/Product/Masonary";
import Footer from "../components/Footer/";
import Seo from "../components/Seo";

const styles = theme => ({
  showcase: {}
});

class CategoryTemplate extends React.Component {
  moveNavigatorAside = moveNavigatorAside.bind(this);

  componentDidMount() {
    if (this.props.navigatorPosition === "is-featured") {
      this.moveNavigatorAside();
    }
  }

  render() {
    const { data, pathContext, classes } = this.props;
    const facebook = (((data || {}).site || {}).siteMetadata || {}).facebook;
    const products = data.allProduct.edges.map(edge => edge.node).filter(p => p.categories.some(c => c.id === pathContext.categoryId));
    return (
      <Main>
        <div style={{
          backgroundImage: `url(${data.category.bannerurl})`,
          backgroundSize: 'cover',
          display: 'flex',
          alignItems: 'flex-end',
          borderBottomLeftRadius: 10,
          borderBottomRightRadius: 10,
          margin: '0 10px',
          boxShadow: '1px 2px 10px 1px #888484',
          marginBottom: 20
        }}>
          <h1
            style={{
              padding: '20px 30px',
              color: 'white',
              margin: 0,
              flexGrow: 1,
              background: '#6c6c6c75',
              borderBottomLeftRadius: 10,
              borderBottomRightRadius: 10,
              fontWeight: 1000,
              fontSize: 32

            }}
          >
            {data.category.name}

          </h1>
        </div>
        {/* <div>
          <FacebookProvider appId="629681694113783">
            <Like href="http://www.facebook.com" colorScheme="light" showFaces share />
          </FacebookProvider>
        </div> */}
        <Masonary className={classes.showcase} products={products} />
      </Main >
    );
  }
}

CategoryTemplate.propTypes = {
  data: PropTypes.object.isRequired,
  pathContext: PropTypes.object.isRequired,
  navigatorPosition: PropTypes.string.isRequired,
  setNavigatorPosition: PropTypes.func.isRequired,
  isWideScreen: PropTypes.bool.isRequired,
  classes: PropTypes.node.isRequired
};

const mapStateToProps = (state, ownProps) => {
  return {
    navigatorPosition: state.navigatorPosition,
    isWideScreen: state.isWideScreen
  };
};

const mapDispatchToProps = {
  setNavigatorPosition,
  setNavigatorShape
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectSheet(styles)(CategoryTemplate));

//eslint-disable-next-line no-undef
export const postQuery = graphql`
query CategoryById($categoryId: String!) {
  category: category(id: {eq: $categoryId}) {
    id
    name
    bannerurl
  }
  allProduct {
    edges {
      node {
        id
        title
        excerpt
        categories{
          id
        }
        fields {
          formattedPrice
          thumbnailUrl
          pageUrl
        }
      }
    }
  }
  site {
    siteMetadata {
      facebook {
        appId
      }
    }
  }
}
`;



// WEBPACK FOOTER //
// ./src/templates/CategoryTemplate.js